module.exports = __webpack_public_path__ + "static/media/1024636.4308bba3.jpg";